export interface Convocatoria {
  actividades: Array<actividadesconvocatoriaModel>;
  area: Array<areaconvocatoriaModel>;
  bolsa_concursable: boolean;
  categoria_linea_convocatoria: Array<any>;
  categorias: Array<Object>;
  ciclo: string;
  cobertura: string;
  descripcion_corta: string;
  documentos_tecnicos: Array<documentosconvocatoriaModel>;
  documentos_generales: Array<documentosconvocatoriaModel>;
  documentos_administrativos: Array<documentosconvocatoriaModel>;
  entidad: string;
  esconvenio: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  fechas: Array<fechasconvocatoriaModel>;
  idconvocatorias: number;
  linea_convocatoria: number;
  linea_estrategica: string;
  menor_edad: boolean;
  modalidad: string;
  nombre_convocatoria: string;
  noparticipa: string;
  num_estimulos: number;
  numero_convocatoria: number;
  objetivo: string;
  perfil_participante: string;
  propuestas: Array<Object>;
  pseudonimo: boolean;
  publico: boolean;
  portada_url?: string;
  tipo_estimulo: string;
  tipo_participante: Array<tipoparticipanteModel>;
  usuario_creacion: string;
  usuario_modificacion: string;
  valor_total_entg: number;
  tipo: number;
  seq_artista: number;
  seq_jurado: number;
  seq_beps: number;
  estado: string;
  nombre_linea?: string;
  linea_nombre?: string;
  lineas_convocatoria?: string;
  linea?: string | any;
}

export interface Convocatoria2 {
  actividades: Array<actividadesconvocatoriaModel>;
  area: Array<areaconvocatoriaModel>;
  bolsa_concursable: boolean;
  categoria_linea_convocatoria: Array<any>;
  categorias: Array<Object>;
  ciclo: string;
  cobertura: string;
  descripcion_corta: string;
  documentos_tecnicos: Array<documentosconvocatoriaModel>;
  documentos_generales: Array<documentosconvocatoriaModel>;
  documentos_administrativos: Array<documentosconvocatoriaModel>;
  entidad: string;
  esconvenio: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  estado: string;
  fechas: Array<fechasconvocatoriaModel>;
  idconvocatorias: number;
  linea_convocatoria: number;
  linea_estrategica: string;
  menor_edad: boolean;
  modalidad: string;
  nombre_convocatoria: string;
  noparticipa: string;
  num_estimulos: number;
  numero_convocatoria: number;
  objetivo: string;
  perfil_participante: string;
  propuestas: Array<Object>;
  pseudonimo: boolean;
  portada_url?: string;
  publico: boolean;
  tipo_estimulo: string;
  tipo_participante: Array<tipoparticipanteModel>;
  usuario_creacion: string;
  usuario_modificacion: string;
  valor_total_entg: number;
  tipo: number;
  seq_artista: number,
  seq_jurado: number,
  seq_beps: number,
  nombre_linea?: string;
  linea_nombre?: string;
  lineas_convocatoria?: string;
  linea?: string | any;
}

interface actividadesconvocatoriaModel {
  check: boolean;
  idactividad: number;
  key: number;
  nombre: string;
}

export interface LineaConvocatoria {
  idlineaconvocatoria: number;
  nombre: string;
}

interface areaconvocatoriaModel {
  text: string;
  value: string;
}

export interface CategoriaLineaConvocatoria {
  id_linea_convocatoria: number;
  idcategorialineaconvocatoria: number;
  nombre: string;
}

export interface documentosconvocatoriaModel {
  descripcion: string;
  documentoActualizado: boolean;
  fecha_creacion: string;
  id: number;
  idconvocatoria: number;
  obligatorio: boolean;
  subsanable: boolean;
  tipo_documento: string;
  tipo_documento_id: number;
  tipo_persona: number;
  url_documento: string;
  url_participante: string;
}

interface fechasconvocatoriaModel {
  clave: string;
  id: number;
  id_convocatoria: number;
  valormax: string;
  valormin: string;
}

interface tipoparticipanteModel {
  value?: number;
  text: string;
}

export const initialValuesConvocatoria2 = {
  actividades: [],
  area: [],
  bolsa_concursable: false,
  categoria_linea_convocatoria: [],
  categorias: [],
  ciclo: "",
  cobertura: "",
  descripcion_corta: "",
  documentos_tecnicos: [],
  documentos_generales: [],
  documentos_administrativos: [],
  entidad: "",
  esconvenio: false,
  fecha_creacion: "",
  fecha_modificacion: "",
  fechas: [],
  estado: "",
  idconvocatorias: 0,
  linea_convocatoria: 0,
  linea_estrategica: "",
  menor_edad: false,
  modalidad: "",
  nombre_convocatoria: "",
  noparticipa: "",
  num_estimulos: 0,
  numero_convocatoria: 0,
  objetivo: "",
  perfil_participante: "",
  propuestas: [],
  pseudonimo: false,
  publico: false,
  portada_url: "",
  tipo_estimulo: "",
  tipo_participante: [],
  usuario_creacion: "",
  usuario_modificacion: "",
  valor_total_entg: 0,
  tipo: 1,
  seq_artista: 0,
  seq_jurado: 0,
  seq_beps: 0,
};

export const initialValuesConvocatoria = {
  actividades: [],
  area: [],
  bolsa_concursable: false,
  categoria_linea_convocatoria: [],
  categorias: [],
  ciclo: "",
  cobertura: "",
  descripcion_corta: "",
  documentos_tecnicos: [],
  documentos_generales: [],
  documentos_administrativos: [],
  entidad: "",
  esconvenio: false,
  fecha_creacion: "",
  fecha_modificacion: "",
  fechas: [],
  idconvocatorias: 0,
  linea_convocatoria: 0,
  linea_estrategica: "",
  menor_edad: false,
  modalidad: "",
  nombre_convocatoria: "",
  noparticipa: "",
  num_estimulos: 0,
  numero_convocatoria: 0,
  objetivo: "",
  perfil_participante: "",
  propuestas: [],
  pseudonimo: false,
  publico: false,
  tipo_estimulo: "",
  portada_url: "",
  tipo_participante: [],
  usuario_creacion: "",
  usuario_modificacion: "",
  valor_total_entg: 0,
  tipo: 1,
  seq_artista: 0,
  seq_jurado: 0,
  seq_beps: 0,
  estado: ""
};
